import {
  NOTIFICATION_PUSHED,
  NOTIFICATION_MARK_AS_READ,
  CLEAR_NOTIFICATIONS,
  NOTIFICATION_REMOVE_FROM_TOASTS,
  TOGGLE_NOTIFICATIONS,
  LOAD_NOTIFICATIONS,
  NOTIFICATIONS_LOADED,
  NOTIFICATION_MARK_AS_READ_ALL
} from "../actions/types";

const initialState = {
  notifications: [],
  isLoading: false,
  show: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_NOTIFICATIONS:
      return {
        ...state,
        isLoading: true
      };

    case NOTIFICATIONS_LOADED:
      return {
        ...state,
        notifications: action.payload.map(val => ({
          ...val,
          data: val.data.data,
          unread: !Boolean(val.read_at),
          toast: false
        })),
        isLoading: false
      };

    case NOTIFICATION_PUSHED:
      return {
        ...state,
        notifications: [
          ...state["notifications"],
          { ...action.payload, unread: true, toast: true }
        ]
      };

    case NOTIFICATION_MARK_AS_READ:
      return {
        ...state,
        notifications: state.notifications.map((val, index) =>
          val.id === action.payload
            ? {
                ...val,
                unread: false
              }
            : val
        )
      };

    case NOTIFICATION_MARK_AS_READ_ALL:
      return {
        ...state,
        notifications: state.notifications.map(val => ({
          ...val,
          unread: false
        }))
      };

    case NOTIFICATION_REMOVE_FROM_TOASTS:
      return {
        ...state,
        notifications: state.notifications.map((val, index) =>
          val.id === action.payload
            ? {
                ...val,
                toast: false
              }
            : val
        )
      };

    case CLEAR_NOTIFICATIONS:
      return initialState;

    case TOGGLE_NOTIFICATIONS:
      return {
        ...state,
        show: !state.show
      };

    default:
      return state;
  }
};
